import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-[14px] bg-theme-modalbg rounded-lg shadow-xl" }
const _hoisted_2 = {
  key: 0,
  class: "relative border-b border-[#414141] p-4"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "mt-[26px] mb-[42px] tracking-wider grid-cols-4 rounded px-4" }
const _hoisted_5 = { class: "full justify-content-center" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "flex flex-row justify-evenly items-center px-4 pb-4 gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_custom_modal = _resolveComponent("custom-modal")!

  return (_ctx.vg_active)
    ? (_openBlock(), _createBlock(_component_custom_modal, {
        key: 0,
        size: 'max-w-[450px]'
      }, {
        maincontent: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.vg_noMsg==null || _ctx.vg_noMsg==false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("h2", {
                    class: "text-xl leading-6 tracking-[0.15px] font-bold text-white text-center",
                    innerHTML: _ctx.vg_msg
                  }, null, 8, _hoisted_3),
                  _createElementVNode("span", {
                    class: "absolute right-4 top-5 pointer cursor-pointer hover:opacity-60",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.reject()), ["prevent"]))
                  }, [...(_cache[4] || (_cache[4] = [
                    _createElementVNode("svg", {
                      width: "14",
                      height: "14",
                      viewBox: "0 0 14 14",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("path", {
                        d: "M1.2248 13.8248L0.174805 12.7748L5.9498 6.9998L0.174805 1.2248L1.2248 0.174805L6.9998 5.9498L12.7748 0.174805L13.8248 1.2248L8.0498 6.9998L13.8248 12.7748L12.7748 13.8248L6.9998 8.0498L1.2248 13.8248Z",
                        fill: "white"
                      })
                    ], -1)
                  ]))])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("p", {
                  class: "text-center text-white text-base leading-5 font-normal",
                  innerHTML: _ctx.vg_extraMsg
                }, null, 8, _hoisted_6)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.vg_confirmLeft)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.accept()), ["prevent"])),
                    class: _normalizeClass(["uppercase text-sm leading-[17.5px] tracking-[0.15px] w-full h-[44px] border-0 rounded-md p-2 block mx-auto", _ctx.vg_confirmClass?_ctx.vg_confirmClass:'bg-theme-green hover:bg-theme-darkgreen text-white'])
                  }, _toDisplayString(_ctx.vg_confirmText), 3))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.reject()), ["prevent"])),
                class: _normalizeClass(["uppercase hover:opacity-50 text-sm leading-[17.5px] tracking-[0.15px] w-full rounded-md p-2 h-[44px] block mx-auto", _ctx.vg_cancelClass?_ctx.vg_cancelClass:'text-white border'])
              }, _toDisplayString(_ctx.vg_cancelText), 3),
              (!_ctx.vg_confirmLeft)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.accept()), ["prevent"])),
                    class: _normalizeClass(["uppercase text-sm leading-[17.5px] tracking-[0.15px] w-full h-[44px] border-0 rounded-md p-2 block mx-auto", _ctx.vg_confirmClass?_ctx.vg_confirmClass:'bg-theme-green hover:bg-theme-darkgreen text-white'])
                  }, _toDisplayString(_ctx.vg_confirmText), 3))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}